/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import { FiveStarRatingContext } from './FiveStarRating_v2';

const FiveStarList = props => {
  const { children } = props;

  const { starColor = '#B2B6CA', shape = 'star' } = useContext(
    interactionContext
  ).props;
  const { rating, onUpdateRating } = useContext(FiveStarRatingContext);

  const [hoverIndex, setHoverIndex] = useState<number | undefined>();

  const shapesRoot = useRef<HTMLDivElement>(null);
  const shapesContainer = useRef<HTMLDivElement>(null);

  const shapesRootDefaultPadding = 50;

  useEffect(() => {
    if (!shapesRoot.current || !shapesContainer.current) {
      return;
    }

    const onResize = () => {
      if (!shapesRoot.current || !shapesContainer.current) {
        return;
      }

      const winWidth = window.innerWidth;
      if (winWidth >= 1100) {
        return;
      }

      const scaleFactor = winWidth / 1100;

      shapesRoot.current.style.padding = `${shapesRootDefaultPadding *
        scaleFactor}px`;

      shapesContainer.current.style.transform = `scale(${scaleFactor})`;
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div
      ref={shapesRoot}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: ${shapesRootDefaultPadding}px;
      `}
    >
      <div
        key={shape}
        ref={shapesContainer}
        className="fader_-5s"
        css={css`
          display: flex;
          // margin: 0 0 20px 0;
        `}
      >
        {children.map((child, index) =>
          React.cloneElement(child, {
            key: `child_${index}`,
            index,
            shape,
            color: starColor,
            onHover(index) {
              setHoverIndex(index);
            },
            isHovered: hoverIndex && hoverIndex >= index,
            rating,
            selected: rating !== null && index <= rating,
            onClick() {
              onUpdateRating(index);
            },
          })
        )}
      </div>
    </div>
  );
};

export default FiveStarList;
